import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormLabel,
  Grid,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LabeledCheckbox from "../../TemplateProperties/TPCheckbox";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../../redux/api";
import LooksOneOutlinedIcon from '@mui/icons-material/LooksOneOutlined';
import { validateOnFlow } from "../../../utils/validate";
import { isEmpty } from "lodash";

const NumberFormatter = (props) => {
  const {
    openModal,
    docPath,
    cancelHandler,
    fieldValue,
    precision,
    okHandler,
    roundInit,
    setNumberFormatterModal
  } = props;
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  const [precisionValue, setPrecisionValue] = useState("");
  const [precisionError,setPresionError] = useState('');
  const [testValue, setTestValue] = useState("");
  const [testResult, setTestResult] = useState("");
  const [checkbox, setCheckbox] = useState(false);
  const { account, user } = useSelector((state) => state.queryParams);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const fieldLabel = t("TIT_NUMBER_FORMATTER")?.split(' ')
  fieldLabel?.splice(1,1,t('FORMAT')) //Temporarily getting required string from two localized String. Added This Srting requirement in BG-8538 

  const testHandler = () => {
    setLoading(true);
    dispatch(
      api.endpoints.number_formatter.initiate({
        account,
        user,
        data_string: testValue,
        pattern: value,
        precision_value: precisionValue,
        check_box: checkbox,
      })
    ).then((res) => {
      if (res?.data?.current_state === "SUCCESS") {
        setError("");
        setTestResult(res?.data?.message);
      } else {
        const errorMssg = res?.data?.message;
        setError(errorMssg);
      }
    })
    .finally(() => {
      setLoading(false);
    })
  };

  const precisionHandler =(e)=>{
    const {value} = e.target;
    const rule = {
      custom: {
        custom:(value) => isNaN(value),
        message: t('BOX_ENTER_VALID_NUMBER_FOR_PRECISION')
      }
    }
    const validationError = validateOnFlow("custom",value,rule);
    const isEmptyObj = isEmpty(validationError);
    if(isEmptyObj){
      setPrecisionValue(value);
    }else{
      setPresionError(validationError.custom);
    }


  }

  useEffect(() => {
    setValue(fieldValue);
    setError("");
    setTestValue("");
    setTestResult("");
    if (precision) setPrecisionValue(precision);
    else setPrecisionValue("");
    if (roundInit) setCheckbox(roundInit);
    else setCheckbox(false);
  }, [openModal]);


  useEffect(()=>{
    if(error){
      setTimeout(()=>{setError("")},3000)
    }
    if(precisionError){
      setTimeout(()=>{setPresionError("")},3000)
    }
  },[error,precisionError])

  return (
    <>
      <Dialog open={openModal} maxWidth={"lg"} fullWidth={true} onClose={() => setNumberFormatterModal(false)}>
        <DialogTitle className="dialog-header">
          <div className="title">{t("DIAG_NUMBER_PATTERN_BUILDER_TIT")}</div>
        </DialogTitle>
        <DialogContent
          className="dialog-content"
          sx={{ height: "70vh", maxHeight: "70vh", overflow: "hidden" }}
          dividers
        >
          <Grid container spacing={1} columns={13}>
            <Grid item xs={7} sx={{padding: "8px"}}>
              {docPath ? (
                <iframe
                  style={{height:"70vh"}}
                  className="docFrame"
                  title="numberPattern"
                  src={docPath}
                ></iframe>
              ) : (
                ""
              )}
            </Grid>
            <Divider orientation="vertical" flexItem/>
            
            <Grid item xs={5} style={{ height: "80vh" }}>
              <Box
                className="dp-actions"
                sx={{ display: "grid", gap: "0.7rem" }}
              >

                <div className="dialog-header" style={{margin:'10px 0px'}}>
                  <div className="title">{t("DIAG_NUMBER_PATTERN_BUILDER_DESC")}</div>
                </div>
                <TextField
                  variant="outlined"
                  size="small"
                  label={fieldLabel?.join(' ')}
                  className="width-100"
                  name={"DATEPATTERN"}
                  error={error?.pattern || false}
                  autoFocus
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                />
                <Box
                  className="width-100"
                  sx={{
                    gap: "0.5rem",
                    display: "grid",
                    gridTemplateColumns: "48% 52%",
                    justifyContent:'space-between'
                  }}
                >
                  <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_PRECISION")}
                    className="width-100"
                    error={error?.precision || false}
                    value={precisionValue}
                    onChange={(e) => precisionHandler(e)}
                  />
                  <Box sx={{width:"100%"}}>
                    <LabeledCheckbox
                        checked={checkbox}
                        handleCheck={() => setCheckbox(!checkbox)}
                        label={t("BTN_ALLOW_ROUNDING_FOR_FLOAT")}
                      />
                  </Box>
                </Box>
                {precisionError && (
                  <span
                    style={{
                      fontSize: "12px",
                      margin: "auto 2px",
                      color: "red",
                    }}
                  >
                    {precisionError}
                  </span>
                )}
                <Box
                  sx={{
                    gap: "0.5rem",
                    display: "grid",
                    width:'100%',
                    gridTemplateColumns: "75% 25%",
                  }}
                >
                  <TextField
                    variant="outlined"
                    size="small"
                    label={t("LBL_TEST_DATA")}
                    className="width-100"
                    name={"NUMBERPATTERN"}
                    error={error?.data || false}
                    value={testValue}
                    onChange={(e) => setTestValue(e.target.value)}
                  />
                  <Box className="width-100">
                    <Button
                      size="small"
                      onClick={testHandler}
                      variant={"outlined"}
                      sx={{width:'95%'}}
                    >
                      {loading ? <CircularProgress size={"16px"}/> :t("BTN_TEST_IT")}
                    </Button>
                  </Box>
                </Box>
                {error && (
                  <span
                    style={{
                      fontSize: "12px",
                      margin: "auto 2px",
                      color: "red",
                    }}
                  >
                    {error}
                  </span>
                )}
                <TextField
                  variant="outlined"
                  size="small"
                  label={t("LBL_TEST_RESULT")}
                  className="width-100"
                  rows={5}
                  rowsmax={10}
                  multiline
                  name={"DATEPATTERN"}
                  value={testResult}
                  onChange={()=>{}}
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className="dialog-header">
          <Button
            size="small"
            onClick={() => {
              okHandler({
                PATTERN: value,
                PRECISION: precisionValue,
                ROUND: checkbox,
              });
            }}
            variant={"outlined"}
          >
            {t("APPLY")} 
          </Button>
          <Button
            size="small"
            onClick={() => {
              cancelHandler(false);
            }}
            variant={"outlined"}
          >
            {t("CANCEL")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default NumberFormatter;
